import { render, staticRenderFns } from "./SocialBar.vue?vue&type=template&id=2c5dc8b1&"
import script from "./SocialBar.vue?vue&type=script&lang=js&"
export * from "./SocialBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports